import { BaseService } from "./common/base";
import type { Appointment } from "../../../../api/src/appointment/entities/appointment.entity";

export class AppointmentAsyncService extends BaseService<Appointment> {
  constructor() {
    super("appointment-async");
  }

  public mine(params?: { limit?: number }) {
    return this._get(`mine`, { params });
  }
}
